import fetchInterceptor , {FetchOptions} from "../../../utils/fetchInterceptor ";
import { newsEndpoints } from "../apiEndPoints";

const EditNewsAPI = async (id: string, newsData: FormData) => {
    const url = newsEndpoints.update(id);
    const options: FetchOptions = {
        method: "PUT",
        body: newsData, // Pass the FormData object directly
    };
    return fetchInterceptor(url, options);
};

export default EditNewsAPI;